import { useMemo } from 'react';

import { handleEditorBreadcrumbsQueryResult } from './handleEditorBreadcrumbsQueryResult.ts';
import { useExperimentalEditorBreadcrumbsQuery } from './useExperimentalEditorBreadcrumbsQuery.ts';
import type { EditorBreadcrumbsQueryVariables } from './__types__/EditorBreadcrumbsQuery.ts';

export type BreadcrumbsType = Array<{
	url: string | null;
	title: string;
}>;

export function useEditorBreadcrumbs(
	contentId?: EditorBreadcrumbsQueryVariables['contentId'],
): BreadcrumbsType {
	const { data, error } = useExperimentalEditorBreadcrumbsQuery({
		variables: {
			contentId: contentId!,
		},
		skip: !contentId, // The template editor does not carry a contentId.
	});

	return useMemo(() => {
		return handleEditorBreadcrumbsQueryResult(data, error);
	}, [data, error]);
}
